module.exports = __webpack_public_path__ + "static/media/paw.1a8c624f.svg";